import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import "./LearningResources.css";

function LearningResources() {
  return (
    <>
      <div>
        <h2>The Learning Resources</h2>
        <Tabs>
          <div className="tabWrapper">
            <TabList>
              <Tab>Learning Management Systems</Tab>
              <Tab>Assessment Platform</Tab>
              <Tab>Learning Platform</Tab>
              <Tab>Learning Labs</Tab>
            </TabList>

            <TabPanel>
              <div className="iconCards-Wrap">
                <div className="cardItem">
                  <a
                    href="https://deepknowledge.accenture.com/login/index.php"
                    target="_blank"
                  >
                    <img
                      src="images/Home/Icons/DKP.png"
                      className="iconImage"
                    />
                    <h3>
                      Deep Knowledge Portal{" "}
                      <img src="images/Home/Icons/Link-icon.png" />
                    </h3>
                  </a>
                </div>
                <div className="cardItem">
                  <a
                    // href="https://mylearning.accenture.com/mylearningui/learner/home"
                    href="https://workday.accenture.com"
                    target="_blank"
                  >
                    <img
                      src="images/Home/Icons/myLearning.png"
                      className="iconImage"
                    />
                    <h3>
                      myLearning <img src="images/Home/Icons/Link-icon.png" />
                    </h3>
                  </a>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div className="iconCards-Wrap">
                <div className="cardItem">
                  <a
                    href="https://deepknowledge.accenture.com/login/index.php"
                    target="_blank"
                  >
                    <img
                      src="images/Home/Icons/DKP.png"
                      className="iconImage"
                    />
                    <h3>
                      Deep Knowledge Portal{" "}
                      <img src="images/Home/Icons/Link-icon.png" />
                    </h3>
                  </a>
                </div>
                <div className="cardItem">
                  <a href="https://mettl.com/corporate/login" target="_blank">
                    <img
                      src="images/Home/Icons/Mettl.png"
                      className="iconImage"
                    />
                    <h3>
                      Mettl <img src="images/Home/Icons/Link-icon.png" />
                    </h3>
                  </a>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div className="iconCards-Wrap">
                <div className="cardItem">
                  <a  href="https://accenture.percipio.com/" 
                      target="_blank"
                  >
                    <img
                      src="images/Home/Icons/Percipio.png"
                      className="iconImage"
                    />
                    <h3>
                      Percipio <img src="images/Home/Icons/Link-icon.png" />
                    </h3>
                  </a>
                </div>
                {/* <div className="cardItem">
                  <a
                    href="https://app.pluralsight.com/library/"
                    target="_blank"
                  >
                    <img
                      src="images/Home/Icons/Pluralsight.png"
                      className="iconImage"
                    />
                    <h3>
                      Pluralsight <img src="images/Home/Icons/Link-icon.png" />
                    </h3>
                  </a>
                </div> */}
                {/* <div className="cardItem">
                  <a
                    href="https://connectedlearning.accenture.com/"
                    target="_blank"
                  >
                    <img
                      src="images/Home/Icons/Learning Boards.png"
                      className="iconImage"
                    />
                    <h3>
                      Learning Boards{" "}
                      <img src="images/Home/Icons/Link-icon.png" />
                    </h3>
                  </a>
                </div> */}
                <div className="cardItem">
                  <a
                    href="https://ts.accenture.com/sites/SecurityLearningGuidanceWizard/SecurityAcademy/SiteAssets/index.aspx#Ecosystem"
                    target="_blank"
                  >
                    <img
                      src="images/Home/Icons/Alliance-partner-portal.png"
                      className="iconImage"
                    />
                    <h3>
                      {/* Alliance partner portal{" "} */}
                      Ecosystem Partner{" "}
                      <img src="images/Home/Icons/Link-icon.png" />
                    </h3>
                  </a>
                </div>
                <div className="cardItem">
                  <a
                    //href="https://login.www.cyberbitrange.com/u/login"
                    href="https://www.udacity.com"
                    target="_blank"
                  >
                    <img
                      src="images/Home/Icons/CyberbitSimulationPlatform.png"
                      className="iconImage"
                    />
                    <h3>
                      Cyber Security Learning Platform{" "}
                      <img src="images/Home/Icons/Link-icon.png" />
                    </h3>
                  </a>
                </div>
                <div className="cardItem">
                  <a
                    href="https://in.accenture.com/intelligentknowledgeexperience/"
                    target="_blank"
                  >
                    <img
                      src="images/Home/Icons/KnowledgeExchange.png"
                      className="iconImage"
                    />
                    <h3>
                      Knowledge Exchange{" "}
                      <img src="images/Home/Icons/Link-icon.png" />
                    </h3>
                  </a>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div className="iconCards-Wrap">
                <div className="cardItem">
                  {/* <a href="" target="_blank"> */}
                    <img
                      src="images/Home/Icons/CloudLabs.png"
                      className="iconImage"
                    />
                    <h3 className="cardItemHead">
                      {/* Cloud Labs <img src="images/Home/Icons/Link-icon.png" /> */}
                      Cloud Labs
                    </h3>
                  {/* </a> */}
                </div>
                <div className="cardItem">
                  {/* <a
                    // href="https://login.www.cyberbitrange.com/u/login"
                    href=""
                    target="_blank"
                  > */}
                    {" "}
                    <img
                      src="images/Home/Icons/Cyberbit.png"
                      className="iconImage"
                    />
                    <h3 className="cardItemHead">
                      {/* Cyber security learning platform <img src="images/Home/Icons/Link-icon.png" /> */}
                      Cyber security learning platform
                    </h3>
                  {/* </a> */}
                </div>
              </div>
            </TabPanel>
          </div>
        </Tabs>
      </div>
    </>
  );
}

export default LearningResources;
